module.exports = __webpack_public_path__ + "302fa0bff85d4d15804ec1c51ef5d664.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/baoxian_c.png
// module id = 821
// module chunks = 3